import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from './Icons';
const faqs = [{
  q: '¿Tengo que pasar horas en la cocina?',
  a: "Absolutamente no. El programa incluye técnicas de 'Batch Cooking' para que prepares tus bases en 90 minutos a la semana y tus comidas diarias tarden menos de 10 min."
}, {
  q: '¿Es otra dieta Keto o de pasar hambre?',
  a: 'No. De hecho, te enseñamos por qué las dietas extremas están arruinando tus hormonas. Aquí comerás carbohidratos inteligentes y grasas ricas para calmar tu sistema.'
}, {
  q: 'Ya estoy en la menopausia, ¿funciona?',
  a: 'Especialmente en esta etapa. El programa se enfoca en la regulación del cortisol y la insulina, que son las llaves maestras del peso a partir de los 40.'
}, {
  q: 'Tengo poco tiempo, ¿es difícil seguirlo?',
  a: 'Está hecho para mujeres reales con trabajos, hijos y vidas ocupadas. Las técnicas de reducción de estrés toman 60 segundos y las rutinas de ejercicio solo 15 minutos.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-cream-light" data-id="element-1">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-charcoal mb-4" data-id="element-4">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-charcoal-light font-sans" data-id="element-5">
            Resolvemos todas tus dudas antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-6">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white border border-cream rounded-xl overflow-hidden shadow-sm" data-id="element-7">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-8">
                <span className="font-playfair font-bold text-lg text-charcoal pr-4" data-id="element-9">
                  {faq.q}
                </span>
                <span className="text-sage shrink-0" data-id="element-10">
                  {openIndex === index ? <MinusIcon data-id="element-11" /> : <PlusIcon data-id="element-12" />}
                </span>
              </button>

              <AnimatePresence data-id="element-13">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-14">
                    <div className="px-6 pb-5 text-charcoal-light font-sans leading-relaxed border-t border-cream pt-4" data-id="element-15">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}